import { Component } from 'nuxt-property-decorator';
import { Context } from '@nuxt/types';
import BinderBase from '@/components/shared/binder-base';
import { parseBinderItemsResponse } from '@/utils/binderFoldersUtils';
import { MetaInfo } from 'vue-meta';

@Component
export default class SharedBinderById extends BinderBase {
  head(): MetaInfo {
    return {
      title: this.binder ? `${this.binder.name}の共有バインダー` : '',
    };
  }

  async asyncData({
    app: { $repositories, $auth },
    error,
    route,
  }: Context): Promise<Pick<SharedBinderById, 'binder' | 'folder' | 'id' | 'items'> | undefined> {
    if (!$auth.permissions.binder) {
      error({ statusCode: 403, message: 'このページは閲覧できません' });
    } else {
      const id = route.params.id;
      try {
        const { binder, folder, items } = parseBinderItemsResponse(
          await $repositories.binderFolders.getSharedBinderItems(id),
        );
        return { binder, folder, id, items };
      } catch (error) {
        console.error(error);
        throw new Error(
          '一覧データの読み込みに失敗しました。このバインダーは共有したユーザーが削除した可能性があります',
        );
      }
    }
  }
}
